import { http } from '@/services/http_service';
export default {
    fetchBanners(context)
    {
        return http()
        .post("/banner/fetchBanners")
        .then((response) => {
            //context.commit('setMessages', response.data)
            //console.log(response.data)
            console.log("배너 확인",response.data);

            context.commit('setBanners', response.data)

            return response.data;
        },function(error){
            console.log(error.response.data)
        });
    },    
}